module.exports = __webpack_public_path__ + "img/lstees.e3be1341.svg";